document.addEventListener("click", function (e) {
  const btn = e.target.closest(".quantity__button_plus, .quantity__button_minus");
  if (!btn) return;

  // Only fire inside the minicart
  if (!btn.closest(".minicart__wrapper")) return;

  const input = btn.closest(".quantity")?.querySelector("input.quantity-input");
  if (!input) return;

  const key = input.dataset.id;
  if (!key) return;

  // Wait for the native quantity-input element to update the value first
  setTimeout(function () {
    const quantity = parseInt(input.value) || 0;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: key, quantity: quantity }),
    })
      .then((res) => res.json())
      .then((cart) => {
        // Update subtotal
        document.querySelectorAll("[data-cart-subtotal-price]").forEach((el) => {
          el.textContent = formatMoney(cart.total_price);
        });

        // Update cart count badges
        document.querySelectorAll(".cart-count").forEach((el) => {
          el.innerHTML = el.classList.contains("cart-count-drawer")
            ? `(${cart.item_count})`
            : cart.item_count > 100 ? "~" : cart.item_count;
        });

        // Remove row if quantity is zero
        if (quantity === 0) {
          const row = document.getElementById(`minicart__product-${key}`);
          if (row) row.remove();
        }
      })
      .catch((err) => console.error("Cart update error:", err));
  }, 50);
});

function formatMoney(cents) {
  if (window.Shopify && window.Shopify.formatMoney) {
    const fmt =
      (window.theme && window.theme.moneyFormat) ||
      (window.themeVariables && window.themeVariables.moneyFormat) ||
      "Rs. {{amount}}";
    return window.Shopify.formatMoney(cents, fmt);
  }
  return "Rs. " + (cents / 100).toFixed(2);
}